import { Suspense } from 'react';

import { Outlet, useSearchParams } from 'react-router-dom';

import { Box } from '@mui/material';

import { BottomNavigation } from '~components/layout/bottom-navigation/bottom-navigation';
import { TenantSidebar } from '~components/layout/sidebar/tenant-sidebar';

import { useScrollToFromUrl } from '~hooks/layout/use-scroll-to-from-url';

import { Header } from './header/header';

export const TenantLayout = () => {
  const [, setSearchParams] = useSearchParams();
  useScrollToFromUrl(setSearchParams);

  return (
    <Box>
      <Box
        sx={{
          display: 'flex',
        }}
      >
        <TenantSidebar />
        <Box sx={{ width: { xs: '100%', md: 'calc(100% - 268px)' } }}>
          <Header />
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </Box>

        <BottomNavigation />
      </Box>
    </Box>
  );
};
